export default "__VITE_ASSET__C6csr5mw__"